/**
 * Fetch attachment CDN URLs. Auth is carried in the URL (CloudFront or S3 presign),
 * not browser cookies — plain fetch avoids credentialed CORS preflights to f.* hosts.
 */
const fetchMedia = (url, init = {}) => fetch(url, init);

export default fetchMedia;
